import { Component } from '@angular/core';
import * as _ from 'lodash';
import moment from 'moment';
import * as debug from 'debug';
import { NavController } from 'ionic-angular';
import { CrudApiProvider } from '../../providers/crud-api/crud-api';
import { UserProvider } from '../../providers/user/user';
import { EnvVariables } from '../../environments/environment';
import { ToolsProvider } from '../../providers/tools/tools';
import * as $ from 'jquery';
import { ConfigProvider } from '../../providers/config/config';

@Component({
  selector: 'speed-bumps',
  templateUrl: 'speed-bumps.html',
})
export class SpeedBumpsComponent {
  log = debug('app:SpeedBumpsComponent');

  oldEnoughUser: boolean = false;
  speedBumpQuestions: {
    key?: string;
    lastSeen?: any;
    header?: string;
    isMultiSelect?: boolean;
    isSlideUp?: boolean;
    showOptions?: boolean;
    subText?: string;
    options?: {
      text?: string;
      value?: string;
    }[];
    selectors?: {
      text?: string;
      value?: string;
      selected?: boolean;
      // onClick?: () => void;
    }[];
    button?: { text: string; onClick?: () => void };
  }[] = [
    {
      key: 'companyOrOwner',
      lastSeen: null,
      header: 'What type of driver are you?',
      isMultiSelect: false,
      subText:
        'Select your driver type to personalize your feed and discover other drivers to connect with.',
      selectors: [
        {
          text: 'Owner Operator',
          value: 'ownerOperator',
          selected: false,
        },
        {
          text: 'Company Driver',
          value: 'companyDriver',
          selected: false,
        },
        {
          text: 'Lease Purchase',
          value: 'leasePurchase',
          selected: false,
        },
      ],
    },
    {
      key: 'trailerTypes',
      lastSeen: null,
      header: 'What type of freight do you haul?',
      isMultiSelect: true,
      selectors: [
        {
          text: 'Dry Van',
          selected: false,
          value: 'dryVan',
        },
        {
          text: 'Flat Bed',
          selected: false,
          value: 'flatbed',
        },
        {
          text: 'Tanker',
          selected: false,
          value: 'tanker',
        },
        {
          text: 'Refrigerated',
          selected: false,
          value: 'reefer',
        },
        {
          text: 'Doubles/Triples',
          selected: false,
          value: 'doubtrip',
        },
        {
          text: 'Auto Hauler',
          selected: false,
          value: 'hauler',
        },
        {
          text: 'Household Goods',
          selected: false,
          value: 'hhg',
        },
        {
          text: 'Dry Bulk & Pneumatic',
          selected: false,
          value: 'dryBulk',
        },
        {
          text: 'Specialized',
          selected: false,
          value: 'specialized',
        },
        {
          text: 'Double Pup',
          selected: false,
          value: 'doublepups',
        },
        {
          text: 'Hazmat',
          selected: false,
          value: 'hazmat',
        },
        {
          text: 'Intermodal',
          selected: false,
          value: 'intermodal',
        },
      ],
    },
    {
      key: 'endorsements',
      lastSeen: null,
      header: 'Do you have any endorsements?',
      isMultiSelect: true,
      selectors: [
        {
          text: 'H - Hazardous Materials',
          selected: false,
          value: 'hEndorsement',
        },
        {
          text: 'N - Tanker Vehicles',
          selected: false,
          value: 'nEndorsement',
        },
        {
          text: 'T - Doubles/Triples',
          selected: false,
          value: 'tEndorsement',
        },
      ],
    },
    {
      key: 'experience',
      lastSeen: null,
      header: 'How long have you been driving?',
      subText:
        "Don't worry, this isn't your ELD asking. - Select your experience level to personalize your feed and find other drivers to connect with.",
      isMultiSelect: false,
      isSlideUp: true,
      showOptions: false,
      options: [
        {
          text: 'Need CDL Training',
          value: 'needtraining',
        },
        {
          text: 'In CDL Training',
          value: 'intraining',
        },
        {
          text: '1-5 Months',
          value: '1-5_months',
        },
        {
          text: '6-11 Months',
          value: '6-11_months',
        },
        {
          text: '12-23 Months',
          value: '12-23_months',
        },
        {
          text: '2 Years',
          value: '2_years',
        },
        {
          text: '3 Years',
          value: '3_years',
        },
        {
          text: '4 Years',
          value: '4_years',
        },
        {
          text: '5+ Years',
          value: '5+_years',
        },
      ],
      button: {
        text: 'View Experience Options',
        onClick: () => {
          console.log('show experience options');
          this.displayExperienceOptions();
        },
      },
    },
    {
      key: 'cdlLicense',
      lastSeen: null,
      header: 'Do you have a Class A CDL?',
      isMultiSelect: false,
      // subText: 'Truckers only here!',
      selectors: [
        {
          text: 'Yes',
          value: 'yes',
        },
        {
          text: 'No',
          value: 'no',
        },
      ],
    },
    {
      key: 'soloOrTeam',
      lastSeen: null,
      header: 'Solo or Team?',
      isMultiSelect: false,
      subText: 'Roll call ☝️ or ✌️?',
      selectors: [
        {
          text: 'Solo Driver',
          value: 'soloDriver',
        },
        {
          text: 'Team Driver',
          value: 'teamDriver',
        },
      ],
    },
    {
      key: 'militaryExperience',
      lastSeen: null,
      header: 'Are you a veteran?',
      isMultiSelect: false,
      selectors: [
        {
          text: 'Yes',
          value: 'yes',
        },
        {
          text: 'No',
          value: 'no',
        },
      ],
    },
  ];

  speedBumpResponse: {
    key?: string;
    header?: string;
    subText?: string;
    button?: { text: string; onClick?: () => void };
  }[] = [
    {
      key: 'companyOrOwner',
      header: '',
      subText:
        'Thanks for letting us know! Personalize your feed further and ensure your content is tailored for you by completing your profile information.',
      button: {
        text: 'Complete Profile',
        onClick: () => {
          this.goToProfile();
        },
      },
    },
    {
      key: 'trailerTypes',
      header: '👍 10-4!',
      subText:
        'Thanks for the heads up! This helps us to route the best jobs straight to your feed.',
      button: {
        text: 'Explore Jobs',
        onClick: () => {
          this.openJobs();
        },
      },
    },
    {
      key: 'endorsements',
      header: '👍 Copy that!',
      subText:
        'This will help us to show you jobs that are a good fit with your experience.',
      button: {
        text: 'Explore Jobs',
        onClick: () => {
          this.openJobs();
        },
      },
    },
    {
      key: 'experience',
      header: '👍 Copy that!',
      subText:
        "Whether you're a seasoned veteran or you're new to the road we've got a seat for you here!",
      // button: {
      //   text: 'Explore Jobs',
      //   onClick: () => {
      //     this.openJobs();
      //   },
      // },
    },
    {
      key: 'cdlLicense',
      header: 'Whew! 🤣 We thought so, but we had to ask',
      subText:
        'The more accurate your profile information is, the more relevant to your interests and experience your feed will become!',
      button: {
        text: 'Update Your Profile',
        onClick: () => {
          this.goToProfile();
        },
      },
    },
    {
      key: 'soloOrTeam',
      header: '👍 Roger that!',
      subText:
        'The more accurate your profile information is, the easier it will be to connect with drivers like you within the community.',
      // button: {
      //   text: 'Explore Jobs',
      //   onClick: () => {
      //     this.openJobs();
      //   },
      // },
    },
    {
      key: 'militaryExperience',
      header: '',
      subText: '',
      button: {
        text: 'Explore Veterans in Trucking',
        onClick: () => {
          this.openVeterans();
        },
      },
    },
  ];

  currentSpeedBump: any;

  canSubmit = false;

  constructor(
    public user: UserProvider,
    public env: EnvVariables,
    public crudApi: CrudApiProvider,
    public tools: ToolsProvider,
    public navCtrl: NavController,
    public configs: ConfigProvider
  ) {
    this.log('constructed');
    if (moment().diff(moment(this.user.get('dates.created')), 'day') >= 2) {
      this.oldEnoughUser = true;
    }
  }

  async ngOnInit() {
    await this.speedBumpQuestionDisplay();
    if (this.currentSpeedBump) {
      this.tools.logAnalyticsEvent(
        'trackCustom',
        `speedbump-${this.currentSpeedBump.key}-displayed`
      );
    }

    $('#speedBump-slide').appendTo('ion-app');
  }

  speedBumpQuestionDisplay() {
    this.log('speedBumpQuestionDisplay');
    let userInfo = _.get(this.user.info, 'jobSearchInfo') || {};

    let seenSpeedBumps =
      JSON.parse(localStorage.getItem('LAST_SEEN_SPEED_BUMPS')) || {};

    //TODO here - this could all be handled in a function instead of doing the same stuff over and over for each scenario
    _.each(this.speedBumpQuestions, sbq => {
      //handling if we need the data for each speed bump
      let param;

      //DRIVER TYPE
      if (sbq.key === 'companyOrOwner') {
        param = userInfo.companyOrOwner;
      }

      //FREIGHT TYPE
      if (sbq.key === 'trailerTypes') {
        param = _.size(userInfo.trailerTypes);
      }
      //ENDORSEMENTS
      if (sbq.key === 'endorsements') {
        param = _.size(userInfo.endorsements);
      }
      //EXPERIENCE
      if (sbq.key === 'experience') {
        param = userInfo.experience;
      }
      //CDL
      if (sbq.key === 'cdlLicense') {
        param = userInfo.cdlLicense;
      }
      //SOLO OR TEAM
      if (sbq.key === 'soloOrTeam') {
        param = userInfo.soloOrTeam;
      }
      //VETERAN STATUS
      if (sbq.key === 'militaryExperience') {
        param = userInfo.militaryExperience;
      }

      if (this.canShowSpeedBump(sbq.key, seenSpeedBumps, param)) {
        seenSpeedBumps[sbq.key] = moment();
        localStorage.setItem(
          'LAST_SEEN_SPEED_BUMPS',
          JSON.stringify(seenSpeedBumps)
        );
        this.currentSpeedBump = sbq;
        return false;
      }
    });
  }

  canShowSpeedBump(key, seenObj, param) {
    let oneDayAgo = moment().subtract(1, 'd').format('dd hh:mma');
    let seenTime;

    if (_.has(seenObj, `${key}`)) {
      seenTime = moment(seenObj[key]).format('dd hh:mma');
    }

    //no data and havent seen in alotted time
    if (!param && !seenTime) {
      return true;
      //no data and havent seen in last 24hrs
    } else if (!param && oneDayAgo < seenTime) {
      return true;
      //can't show
    } else {
      return false;
    }
  }

  handleMultiSelect(i) {
    this.currentSpeedBump.selectors[i].selected =
      !this.currentSpeedBump.selectors[i].selected;

    if (_.some(this.currentSpeedBump.selectors, ['selected', true])) {
      this.canSubmit = true;
    } else {
      this.canSubmit = false;
    }
    this.handleSubmit(i, { softSubmit: true });
  }

  handleSubmit(selectorIdx: number, opts: { softSubmit?: boolean }) {
    let driverClone = _.cloneDeep(_.get(this.user.info, 'jobSearchInfo') || {});
    let key = this.currentSpeedBump.key;
    let value;
    if (this.currentSpeedBump.isSlideUp) {
      value = this.currentSpeedBump.options[selectorIdx].value;
    } else {
      value = this.currentSpeedBump.selectors[selectorIdx].value;
    }
    let userUpdate;

    if (this.currentSpeedBump.isMultiSelect) {
      userUpdate = {
        jobSearchInfo: {
          [key]: _.union([value], _.get(driverClone, `${key}`)),
        },
      };
    } else {
      userUpdate = {
        jobSearchInfo: {
          [key]: value,
        },
      };
    }

    this.log('user update here', userUpdate, driverClone);

    this.crudApi.put(`/api/users/${this.user.info._id}`, userUpdate).then(
      res => {
        if (!_.get(opts, 'softSubmit')) {
          this.showResponse(key, value);
        } else {
          this.user.forceUpdateUser();
        }
        this.tools.logAnalyticsEvent(
          'trackCustom',
          `speedbump-${key}-dataUpdated`
        );
      },
      e => {
        console.error(e);
      }
    );
  }

  handleMultiSubmit() {
    if (this.canSubmit) {
      let driverClone = _.cloneDeep(
        _.get(this.user.info, 'jobSearchInfo') || {}
      );
      let fieldToUpdate = this.currentSpeedBump.key;
      let values = [];
      _.each(this.currentSpeedBump.selectors, s => {
        if (s.selected) {
          values.push(s.value);
        }
      });
      let userUpdate = {
        jobSearchInfo: {
          [fieldToUpdate]: _.union(driverClone[fieldToUpdate], values),
        },
      };

      this.crudApi.put(`/api/users/${this.user.info._id}`, userUpdate).then(
        res => {
          this.showResponse(fieldToUpdate);
          this.tools.logAnalyticsEvent(
            'trackCustom',
            `speedbump-${fieldToUpdate}-dataUpdated`
          );
        },
        e => {
          console.error(e);
        }
      );
    }
  }

  showResponse(key: string, value?: string) {
    let response;

    //handling custom one offs for certain speedbumps

    //DRIVER TYPE
    if (key === 'companyOrOwner') {
      let header;
      if (value === 'ownerOperator') {
        header = "You're an Owner Operator!";
      } else if (value === 'leasePurchase') {
        header = "You're a Lease Purchase Driver!";
      } else if (value === 'companyDriver') {
        header = "You're a Company Driver!";
      }
      response = _.find(this.speedBumpResponse, r => {
        return r.key === key;
      });

      response.header = header;

      //CDL
    } else if (key === 'cdlLicense') {
      let header, subText;
      if (value === 'yes') {
        header = 'Whew! 🤣 We thought so, but we had to ask';
        subText =
          'The more accurate your profile information is, the more relevant to your interests and experience your feed will become!';
      } else if (value === 'no') {
        header = "Got it! Well we're happy to have you 😊";
        subText =
          'We recommend keeping your profile up to date to ensure that content show is relevant to your current interests and experience. Get rolling today!';
      }
      response = _.find(this.speedBumpResponse, r => {
        return r.key === key;
      });

      response.header = header;
      response.subText = subText;
    } else if (key === 'militaryExperience') {
      let header, subText, button;
      if (value === 'yes') {
        header = '🇺🇸 Thank you for your service!';
        subText = 'Click below to go to Veterans in Trucking!';
      } else if (value === 'no') {
        header = 'Thanks!';
        button = {
          text: 'View Profile',
          onClick: () => {
            this.goToProfile();
          },
        };
      }
      response = _.find(this.speedBumpResponse, r => {
        return r.key === key;
      });

      response.header = header;
      if (subText) {
        response.subText = subText;
      }
      if (button) {
        response.button = button;
      }
    } else {
      response = _.find(this.speedBumpResponse, r => {
        return r.key === key;
      });
    }

    this.currentSpeedBump = response;

    setTimeout(() => {
      this.currentSpeedBump = null;
    }, 5000);
  }

  openJobs() {
    this.tools.logAnalyticsEvent('trackCustom', 'speedbump-jobs-load');
    const base = 'https://dedicatedjobs.cdllife.com';
    this.tools.openExternalUrl(
      `${base}/api/drivers/${encodeURI('MID|' + this.user.get('_id'))}/jobs`,
      '_blank',
      {
        rt: 'mobileApp',
        utm_source: 'cbo-cdllife-mobileApp',
        utm_campaign: 'speedbump-jobs',
      }
    );
  }

  openVeterans() {
    this.tools.openExternalUrl(`https://veteransintrucking.com`, '_blank');
  }

  goToProfile() {
    this.navCtrl.push('UserProfilePage', {
      user: _.get(this.user),
      user_id: _.get(this.user, 'info._id'),
    });
  }

  displayExperienceOptions() {
    this.currentSpeedBump.showOptions = true;
  }

  hideExperienceOptions() {
    this.currentSpeedBump.showOptions = false;
  }
}



// WEBPACK FOOTER //
// ./src/components/speed-bumps/speed-bumps.ts